import {
    useCallback,
} from 'react'
import {
    useQueryClient,
} from '@tanstack/react-query'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'

import requestConfig from 'app/requests/CQuote.requests'

const REQUEST_KEY = RequestKeys.getCQuoteDocuments

const useCQuoteDocuments = (id: number) => {
    const queryClient = useQueryClient()

    const refresh = useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: [REQUEST_KEY],
        })
    }, [queryClient])

    const {
        onParamsChange,
        loadData: load,
    } = useRequestTable({
        key: REQUEST_KEY,
        params: {
            id,
        },
        config: requestConfig.getCQuoteDocuments,
        enabled: Boolean(id),
    })

    return {
        onParamsChange,
        load,
        refresh,
    }
}

export default useCQuoteDocuments
